import {Mapper} from '@s-ui/domain'

import SeoValueObjectsFactory from '../ValueObjects/factory.js'
import SeoMappersFactory from './factory.js'

export class SeoModelSizesMetaInformationMapper extends Mapper {
  constructor({seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper, productStructuredDataSeoMapper, config}) {
    super()
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._productStructuredDataSeoMapper = productStructuredDataSeoMapper
  }

  static create({config}) {
    return new SeoModelSizesMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject,
      productStructuredDataSeoMapper: SeoMappersFactory.productStructuredDataSeoMapper({config})
    })
  }

  /**
   * @method
   */
  async map({culture, pageName, params = {}}) {
    const {make, model, makeSlug, modelSlug} = params

    const {MODEL_DETAIL_SEO} = this._config.get('seo')
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const siteUrl = `${protocol}${host}`

    const {H1, TITLE, META_DESCRIPTION, META_ROBOTS, CANONICAL} = MODEL_DETAIL_SEO[pageName][culture]

    const placeholderValues = {
      make,
      makeSlug,
      model,
      modelSlug,
      siteUrl
    }

    const parsedH1 = this._seoLiteralMapper.setText({text: H1}).setPlaceholderValues({placeholderValues}).map()

    const parsedTitle = this._seoLiteralMapper
      .setText({text: TITLE})
      .setPlaceholderValues({
        placeholderValues
      })
      .map()

    const parsedCanonical = this._seoLiteralMapper
      .setText({text: CANONICAL})
      .setPlaceholderValues({
        placeholderValues
      })
      .map()

    const parsedDescription = this._seoLiteralMapper
      .setText({text: META_DESCRIPTION})
      .setPlaceholderValues({
        placeholderValues
      })
      .map()

    const productStructuredDataVO = this._productStructuredDataSeoMapper.map({
      name: parsedH1,
      make,
      model,
      description: parsedDescription
    })

    const {
      links,
      metas,
      scripts,
      title: seoTitle
    } = this._seoDataMapper
      .title(parsedTitle)
      .canonical(parsedCanonical)
      .description(parsedDescription)
      .addSchemaData(productStructuredDataVO)
      .robots(META_ROBOTS)
      .map()

    return this._seoDataValueObjectFactory({
      h1: parsedH1,
      head: {
        link: links,
        meta: metas,
        scripts,
        title: seoTitle
      }
    })
  }
}
